import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import ProductsList from '../components/productList';
import ScrollTop from '../components/scrollTop';

export default function CategoryPage() {
    const { category, subcategory } = useParams();

    useEffect(()=>{
        window.scrollTo(0,0)
    },[category,subcategory])

    // Helper function to format names
    const formatName = (name) => {
        if (!name) return '';
        return name
            .replace(/-/g, ' ')
            .replace(/\s+/g, ' ')
            .trim()
            .replace(/\b\w/g, (char) => char.toUpperCase());
    };

    const formattedCategory = formatName(category);
    const formattedSubcategory = formatName(subcategory);

    return (
        <div>
            <ScrollTop/>
            <div className="container" style={{marginBottom:'-50px'}}>
                {/* Breadcrumb Navigation */}
                <nav aria-label="breadcrumb" className="mt-4 mb-4">
                    <ol className="breadcrumb">
                        {/* Home Link */}
                        <li className="breadcrumb-item">
                            <Link to="/" className="text-dark text-decoration-none">
                                <i className="fas fa-home me-2"></i> Home
                            </Link>
                        </li>

                        {/* Category (Active if no subcategory, link if subcategory exists) */}
                        {category && (
                            <li
                                className={`breadcrumb-item ${!subcategory ? 'active' : ''
                                    }`}
                                aria-current={!subcategory ? 'page' : undefined}
                            >
                                {!subcategory ? (
                                    <>
                                        <i className="far fa-folder me-2"></i> {formattedCategory}
                                    </>
                                ) : (
                                    <Link
                                        to={`/category/${category}`}
                                        className="text-dark text-decoration-none"
                                    >
                                        <i className="fas fa-shopping-cart me-2"></i> {formattedCategory}
                                    </Link>
                                )}
                            </li>
                        )}

                        {/* Subcategory (Plain text, active) */}
                        {subcategory && (
                            <li className="breadcrumb-item active" aria-current="page">
                                <i className="far fa-folder me-2"></i> {formattedSubcategory}
                            </li>
                        )}
                    </ol>
                </nav>
            </div>

            {/* Products List */}
            <ProductsList category={formattedCategory} subcategory={formattedSubcategory} />
        </div>
    );
}
